import React from "react";
import {
  Container,
  Grid,
} from "@material-ui/core";
import CardStudents from "./CardStudents";
import NewStudent from "./NewStudent";
import { useRole } from "../../hooks/useRole";

export default function Students() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardStudents />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewStudent />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
